import React from 'react';
import { useLocation } from 'react-router';

export const useUrlSearchParams = () => {
  const { search } = useLocation();

  // Utilises URLSearchParams interface that is available in the browsers we support
  // See https://caniuse.com/urlsearchparams
  return React.useMemo(() => new URLSearchParams(search), [search]);
};
